import Component, { mixins } from 'vue-class-component';
import { Prop, Watch, Ref, Vue } from 'vue-property-decorator';
import { BModal } from 'bootstrap-vue';

@Component({
  inheritAttrs: false,
})
export default class VisualizadorPdfComponent extends Vue {
  /**
   * Información base64 que se mostrará en el componente
   */
  @Prop({ required: true })
  contenidoBase64: string;

  /**
   * Se espera que desde el componente Padre se le indique cuando mostrarse
   */
  @Prop({ default: false })
  mostrar: boolean;

  /**
   * Identificador del visualizador
   */
  @Prop({ required: true })
  id: string;

  @Ref('visorPdfModal') visorPdfModal!: BModal;

  /**
   * Indicador para mostrar o no mostrar el visualizador
   */
  @Watch('mostrar')
  onMostrarChange(newMostrar: boolean): void {
    this.visualizar(newMostrar);
  }

  /**
   * Método para mostrar u ocultar el visualizador
   */
  visualizar(mostrar: boolean): void {
    if (this.visorPdfModal) {
      if (mostrar) {
        (this.visorPdfModal as any).show();
      } else {
        (this.visorPdfModal as any).hide();
      }
    }
  }
}
